/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2021 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Translation file for Italian language
 *
 * @file it.js
 * @author Manimaran.S
 */

const it = {
  'popularChannelSlider.allChannels': 'Tutti i Canali',
  'popularChannelSlider.recommended': 'Consigliati',
  'hero.myetextbook.link': 'libreria',
  'hero.myetextbook.text': 'Non è il titolo giusto? Accedi al tuo libro eText',
  'hero.etextfeaturestitle': 'Trova materiali di studio nel tuo libro eText',
  'hero.etextfeaturesdescription': 'Il tuo libro eText dispone di materiali di studio creati per aiutarti ad avere successo. Studia con le flashcard e altro direttamente nel tuo libro eText.',
  'aichat.title1': 'Ottieni aiuto fornito dall’IA per qualunque cosa correlata a questo libro eText',
  'aichat.chatDesc1': 'Digita una domanda per iniziare.',
  'subscriptiontext.isSubscribed': 'Parte del tuo abbonamento',
  'subscriptiontext.nonSubscriber': 'Aggiorna per un accesso completo',
  'topicConatiner.otherHeader': 'Video ed esercizi correlati',
  'topicConatiner.exactLiteHeader': 'Concetti ed esercizi correlati',
  'moremenu.downloadApp': 'Scarica l’app',
  'moremenu.downloadAppAlreadyDownload': '%Click here% per scaricare l\'app su un altro dispositivo e accedere automaticamente o per utilizzare il codice QR univoco per accedere in sicurezza all\'app già installata.',
  'moremenu.downloadAppNotDownload': '%Click here% per scaricare l\'app su un altro dispositivo e accedi in sicurezza con il tuo codice QR univoco',
  'channel.noBundletitle': 'Utilizza Prep allo studio per i tuoi altri corsi e quelli correlati',
  'onboard.studyPlan': 'Piano di studi personalizzato creato!',
  'onboard.addCourseAnother': 'Vuoi aggiungere un altro corso?',
  'onboard.purchase': 'Devo acquistare un libro di testo elettronico di Pearson',
  'onboard.addCourseWithoutEtext': 'Aggiungi corso usando Prep allo studio',
  'onboard.mayBeLater': 'Forse più tardi',
  'onboard.aboutCourse': 'Raccontaci del tuo corso',
  'onboard.close': 'Chiudi',
  'course.addTitle': 'Aggiungi corso',
  'common.PURCHASE': 'Acquista',
  'common.CLOSE': 'Chiudi',
  'open': 'aperti',
  'continue': 'Prosegui',
  'yes': '<b>Sì</b>',
  'no': 'No',
  'audio': 'Audio',
  'courses.toc.PUBLISH_SUCCESS': 'Fatto!',
  'courses.toc.PUBLISH_MESSAGE': 'Gli studenti vedranno le tue modifiche la prossima volta che apriranno i contenuti.',
  'errors.GENERIC_TITLE': 'Non hai accesso in questo momento',
  'errors.GENERIC_DESC': 'Per prima cosa, aggiorna o svuota la cache. Se non funziona, contatta Pearson',
  'errors.GENERIC_LINK': 'supporto.',
  'errors.GENERIC_CODE': 'Codice errore: {code}',
  'errors.SUBSCRIPTION_GENERIC_TITLE': 'Sottoscrizione non trovata',
  'errors.SUBSCRIPTION_GENERIC_DESC': 'Il tuo account non può accedere a questo titolo. Se pensi di aver ricevuto questo\n    messaggio per sbaglio, contatta l’Assistenza tecnica Pearson.',
  'errors.SUBSCRIPTION_REGISTRATION_TITLE': 'Sottoscrizione non trovata',
  'errors.SUBSCRIPTION_REGISTRATION_DESC': 'La tua sottoscrizione non include l’accesso al testo. Tuttavia, puoi registrarti\n    adesso usando una carta di credito.',
  'link.ACCESSIBILITY': 'https://it.pearson.com/accessibilita.html',
  'link.PRIVACY': 'https://it.pearson.com/privacy-policy.html',
  'link.SUPPORT': 'https://it.pearson.com/supporto.html',
  'link.TOSURL': 'https://it.pearson.com/termini-e-condizioni-uso.html',
  'link.FAQS_NONMOJO': '',
  'link.TERMS_OF_USE_NONMOJO': 'https://it.pearson.com/termini-e-condizioni-uso.html',
  'link.PRIVACY_NOTICE_NONMOJO': 'https://it.pearson.com/privacy-policy.html',
  'link.ACCESSIBILITY_SUPPORT_NONMOJO': '',
  'menu.myAccount': 'Il mio account',
  'menu.helpCenter': 'Centro assistenza',
  'menu.preferencesCenter': 'Centro preferenze',
  'menu.CONTACT_SUPPORT': 'Supporto',
  'menu.HELP_SUPPORT': 'Assistenza e supporto',
  'menu.FAQS': 'Domande frequenti (FAQ)',
  'menu.CHAT_WITH_SUPPORT': 'Chatta con il supporto',
  'menu.OTP_CODES': 'Codici OTP',
  'menu.LAUNCH_CODE': 'Avvia il log di codice',
  'menu.SEND_CODE': 'Invia il nuovo codice all\'utente tramite e-mail',
  'menu.SEND_CODE_PHONE': 'Invia il nuovo codice all\'utente tramite SMS',
  'menu.LEGAL': 'Legale',
  'menu.PRIVACY_NOTICE': 'Informativa sulla privacy',
  'menu.TITLE_INFO': 'Info sul titolo',
  'menu.PEARSON_ACCESSIBILITY': 'Accessibilità Pearson',
  'menu.DEVICE_WARNING_MESSAGE': 'Registra {deviceLimit} dispositivi. Scambiane 1 al mese.',
  'menu.ACCESSIBILITY': 'Accessibilità',
  'menu.ACCESSIBILITY_SUPPORT': 'Supporto accessibilità',
  'menu.DEVICES': 'Dispositivi recenti',
  'menu.THIS_DEVICE': 'Questo dispositivo',
  'menu.GET_THE_APP_DOWNLOAD': 'Scarica l’app mobile',
  'menu.MOJO_APP_INFO': 'Vai all\'app store sul telefono o sul tablet per utilizzare Pearson+ offline.',
  'menu.DEVICE_LABEL': 'Dispositivo',
  'menu.DEVICE_DISCONNECT': 'Scollegati',
  'menu.FOXIT': 'Offerto da Foxit',
  'menu.TERMS_OF_USE': 'Termini di utilizzo',
  'menu.SIGN_OUT': 'Disconnetti',
  'menu.PRINT_PAGE': 'Stampa pagina',
  'menu.COPY_RIGHT': 'Copyright © {year} Pearson Education Inc. Tutti i diritti riservati',
  'print.FOOTER_MESSAGE': 'Stampato da {fullName}({email}) il {currentDate}.',
  'print.WATERMARK': 'Copyright © {year} Pearson Education.',
  'device.SWAPPED_ALREADY': 'Per questo mese hai già effettuato lo scambio',
  'device.SWITCH_DEVICE': 'Passare al dispositivo corrente?',
  'device.SWITCH_ONCE': 'Poiché puoi scambiare solo una volta al mese, non ti sarà possibile revocare questa azione.',
  'device.SEAT_TAKEN': 'Quel posto è occupato',
  'device.DISCONNECT_DEVICE': 'Puoi eseguire il login solo su 3 dispositivi. Per proseguire qui, scollega un altro dispositivo.',
  'device.ALERT_TEXT': 'Ricorda che puoi scambiare dispositivi solo una volta al mese.',
  'device.DISCONNECT': 'Scollegati',
  'device.CONTINUE': 'Prosegui',
  'device.HEADER': 'Terminare la sessione sull’altro browser?',
  'device.CLOSE': 'Torna alla pagina iniziale',
  'device.CODE': 'Continua qui inserendo il codice di autenticazione che ti abbiamo inviato {maskedEmail}. Non funziona? Controlla la cartella antispam, {email}, oppure contatta {support}.',
  'device.TIMER': 'È necessario {time} per inserire il codice qui',
  'device.RESEND': '{resend}',
  'device.FAQ': 'DOMANDE FREQUENTI',
  'device.RESEND_NAME': 'Reinviare',
  'device.NOTE': 'Se utilizzi regolarmente Pearson+ in 2 luoghi diversi, ad esempio al lavoro e a casa, assicurati di disconnetterti ogni volta che hai finito. Puoi anche utilizzare l\'app mobile Pearson+ su un massimo di 2 dispositivi. Per maggiori informazioni, consulta la nostra {faq}.',
  'device.NOTE_HEADER': 'Evitalo la prossima volta',
  'device.CONTACT_SUPPORT': 'supporto clienti',
  'device.CONTACT_EMAIL': 'aggiorna la tua mail',
  'device.INCORRECT': 'Non è corretto. Ricontrolla il codice o invialo di nuovo.',
  'device.MANY_ATTEMPTS': 'Troppi tentativi, prova a inviare di nuovo il codice',
  'device.EXPIRED': 'Tempo scaduto, prova a inviare di nuovo il codice',
  'device.ACCESS_HEADER': 'Accesso riuscito!',
  'device.ACCESS_DESC': 'La sessione è stata autenticata. Desideri aggiornare la password mentre ci sei?',
  'device.ACCESS_CHANGE_PASSWORD': 'Cambia password',
  'device.ACCESS_RESET_PASSWORD': 'Reimposta password',
  'device.THREATONE_TITLE': 'Tutto bene?',
  'device.THREATONE_DESC': 'Abbiamo notato delle attività sospette sul tuo account.',
  'device.THREATONE_DESC_TWO': 'Potrebbe essere il momento adatto per cambiare la tua password.',
  'device.MAY_BE_LATER': 'Forse più tardi',
  'device.OKAY': 'OK',
  'device.ACCOUNT_LOCK_DESC': 'Per la tua sicurezza, abbiamo eseguito il logout. Ti abbiamo inviato un link di reset della password all’indirizzo email associato al tuo account.',
  'device.ACCOUNT_LOCK_TITLE': 'Abbiamo notato delle attività sospette sul tuo account',
  'device.ACCOUNT_LOCK_TIMER': 'Sarai disconnesso tra {time}',
  'navigation.PAGE': 'Pagina',
  'launchcode.CREATEBY': 'Creato da:',
  'launchcode.sentvia': 'Inviato via:',
  'launchcode.CODEINLAST': 'Codici negli ultimi 7 giorni:',
  'launchcode.TIMESENT': 'Orario invio:',
  'launchcode.ACCOUNTEMAIL': 'e-mail account:',
  'launchcode.LAUNCHDIALOGTITLE': 'Log codice OTP',
  'textmessage.TITLE': 'Inserisci il tuo numero di telefono',
  'textmessage.PHONE_NUMBER': 'Numero di telefono',
  'textmessage.SEND_CODE': 'Invia codice',
  'textmessage.INVALID_NUMBER': 'Numero di telefono non valido',
  'textmessage.SUCCESS_MESSAGE': 'Codice inviato',
  'remove.title': 'Rimuovere titolo?',
  'remove.subTitle': 'Puoi sempre tornarci in un secondo momento, semplicemente utilizzando la ricerca per aggiungerlo di nuovo.',
  'remove.buttonText': 'Rimuovi',
  'search.searchPlaceHolderPPlus': 'Ricerca per ISBN, titolo o autore',
  'search.searchPlaceHolderEText': 'Cerca nella tua libreria',
  'footer.downloadMobileApp': 'Scarica l’app mobile',
  'footer.termsOfUse': 'Termini di utilizzo',
  'footer.privacy': 'Privacy',
  'footer.cookies': 'Cookie',
  'footer.doNotSellMyPersonalInformation': 'Non vendere i miei dati personali',
  'footer.accessibility': 'Accessibilità',
  'footer.patentNotice': 'Informazioni sui brevetti',
  'footer.copyrights': 'Pearson Tutti i diritti riservati.',
  'hero.toc.defaultPlacehoder': '--- seleziona un argomento ---',
  'hero.openEtextBookV1': 'Apri i libri eText',
  'hero.heroHeading': 'Poiché stai studiando <span>{channel_title}</span>',
  'hero.heroHeadingForBundleUser': 'Prep allo studio',
  'hero.study.help': 'Richiedi un supporto allo studio',
  'hero.study.jumpBackIn': 'Vai indietro',
  'hero.study.numOfUsers': 'Attualmente ci sono <b>{num_of_users}</b> studenti che utilizzano Canali.',
  'hero.heroChannel.cardsHeading': 'Riprendi da dove hai lasciato',
  'hero.marketingcard1.copy.title': 'Impara con i video',
  'hero.marketingcard1.copy.description': 'Guarda dei brevi video di spiegazione che illustrano nel dettaglio gli argomenti più complessi.',
  'hero.marketingcard2.copy.title': 'Problemi pratici',
  'hero.marketingcard2.copy.description': 'Preparati per gli esami con migliaia di quiz pratici e video soluzioni',
  'hero.marketingcard3.copy.title': 'Chiedi aiuto a un esperto',
  'hero.marketingcard3.copy.description': 'Invia delle domande e ricevi delle risposte dagli esperti in materia.',
  'hero.popularTopics.heading': 'Altri argomenti di tendenza in questo Canale',
  'hero.popularChannels.headingv1': 'Stai preparando un altro corso?',
  'hero.popularChannels.descriptionv2': 'Sfoglia gli argomenti di supporto allo studio più popolari.',
  'hero.practice': 'Esercitati',
  'hero.herobook.mappedChannelHeading': 'Supporto allo studio consigliato in questo Canale',
  'libraryL2.myBooks': 'I miei libri',
  'libraryL2.archived': 'Archiviato',
  'libraryL2.back': 'Indietro',
  'hero.practiceProblem': 'Problema pratico',
  'nativeAppBanner.drawer.title': 'Apri in...',
  'nativeAppBanner.drawer.pearsonApp': 'App Pearson+',
  'nativeAppBanner.banner.title': 'App Pearson+',
  'nativeAppBanner.banner.description': 'Impara in movimento',
  'hero.promotionalcard.list1': 'Brevi video di spiegazione che illustrano nel dettaglio gli argomenti più complessi',
  'hero.promotionalcard.list2': 'Migliaia di quiz simili a un esame',
  'hero.promotionalcard.list3': 'Ricevi delle risposte dagli esperti in materia',
  'hero.studyandexamprep': 'Prep allo studio',
  'hero.heroBook.sectionSubHeadingV1': 'Suddividi gli argomenti più complessi con spiegazioni video e domande di esercitazione su misura per il tuo corso.',
  'hero.heroBook.sectionSubHeadingV2': 'Suddividi gli argomenti più complessi con spiegazioni di concetti e domande di esercitazione su misura per il tuo corso.',
  'hero.SeeAllStudyOptions': 'Vedi tutte le opzioni di studio',
  'hero.herobook.mappedChannelHeadingV1': 'Video e domande di esercitazione consigliati',
  'hero.popularTopics.headingV1': 'Altri argomenti popolari',
  'hero.heroHeadingV1': 'Per <span>{replace_value}</span>',
  'hero.learnmore': 'Scopri di più',
  'hero.eTextbook': 'Libri eText',
  'hero.goToPage.label': 'Vai alla pagina',
  'subscription.studyTitle': 'Prep allo studio',
  'print.printAvailTitle': 'Desideri stampare la pagina? Ecco come',
  'print.printAvailDesc': 'Nel tuo libro eText, seleziona l’icona dell’account in alto a destra. Dalle opzioni, scegli “Stampa pagina” e poi scegli le impostazioni di stampa.',
  'print.printNotAvailTitle': 'L’opzione di stampa non è abilitata per questo eText.',
  'print.printNotAvailDesc': 'Per un comodo accesso offline, scarica il tuo titolo tramite l\'app mobile Pearson+ e goditi la flessibilità di studiare sempre e ovunque!',
  'hero.header.cta': 'Vai su Strumenti di studio',
  'hero.header.ctav2': 'Apri Prep allo studio',
  'hero.marketing.title': 'Trova il tuo eText',
  'hero.marketing.subTitle': 'Scegli tra più di 2.000 libri eText con audio, flashcard, appunti e molto altro. Solo a 10,99 $/mese per una sessione di 4 mesi.',
  'hero.popularchannels.desc': 'Ottieni un supporto allo studio in queste materie principali',
  'hero.removecourse.title': 'Rimuovere corso dal Cruscotto digitale?',
  'hero.removecourse.description': 'Puoi riaggiungere il corso al cruscotto digitale facendo clic su "Aggiungi corso"',
  'hero.removecourse.primaryCtaText': 'Rimuovi',
  'hero.removecourse.secondaryCtaText': 'Annulla',
  'hero.tableOfContents': 'Sommario',
  'hero.search': 'Cerca',
  'hero.emptystate.cta': 'Cerca libri eText',
  'hero.watch_it_again': 'Guarda di nuovo',
  'hero.mondly.learnLang.title': 'Impara una nuova lingua gratuitamente',
  'hero.mondly.subTitle': 'Gli utenti Pearson con eTextbook hanno tre mesi gratis di Mondly di Pearson.',
  'hero.mondly.description': 'La maggior parte delle app di insegnamento delle lingue ti permettono di impararle solo dall\'inglese. Ma è meglio impararle partendo dalla propria lingua madre, pertanto Mondly ti permette di imparare da tutte le nostre 41 lingue disponibili.',
  'hero.mondly.startLearningCTA': 'Iniziare l’apprendimento',
  'hero.mondly.marketing.bestApp': 'Migliore App',
  'hero.mondly.marketing.appStore': 'App Store',
  'hero.mondly.marketing.appYear': 'App dell’anno',
  'hero.mondly.marketing.fbStart': 'Facebook FbStart - Vincitore EMEA 2017',
  'hero.mondly.marketing.editorChoice': 'Editor Choice',
  'hero.mondly.marketing.googlePlay': 'Google Play',
  'header.menu.learnLanguage': 'Impara una lingua',
  'header.menu.moreAtPearson': 'Altro da Pearson',
  'hero.subscriptionStatusTitle2': 'Le tue risorse Pearson+',
  'hero.startStudying': 'Inizia a studiare',
  'onboard.studyMaterials': 'Scegli la tua materia e creeremo una dashboard con materiali di studio personalizzati.',
  'hero.myETextbooks': 'I miei Libri eText',
  'header.continueInTheApp': 'Continua nell\'app',
  'hero.learnTxt': 'Formazione',
  'hero.examPrepTxt': 'Preparazione esame',
  'hero.aITutorTxt': 'Tutor AI',
  'AI.toolTip': 'Chiedimi qualsiasi cosa ne tuoi libri eText',
  'hero.studyExamPrepAllYourCourses': 'Prep allo studio per tutti i tuoi corsi',
  'header.qrCode.subHeaderTxt': 'Utilizza questo codice QR per accedere in modo rapido e sicuro all\'app Pearson+ sul tuo dispositivo mobile.',
  'header.qrCode.dontHaveApp': 'Non hai l\'app?',
  'header.qrCode.footerTxt': 'Scansione il codice per visitare l\'App Store e Google Play. Una volta scaricata l\'app, accedi scansionandolo di nuovo.',
  'header.qrCode.errorMsg': 'Caricamento del codice QR non riuscito. Chiudi e riprova.',
  'hero.yourETextbook': 'I tuoi eTextbook',
  'onboard.addCourseWithEtextBundle': 'Aggiungi corso usando Prep allo studio',
  'onboard.disableTooltipText': 'Sono stati aggiunti tutti i corsi di Prep allo studio!',
  'subscriptionstatus.bundlecta': 'Accedi a Prep allo studio',
  'subscriptionstatus.nonbundlecta': 'Accedi a Prep allo studio',
  'channel.genericBundle': 'Utilizza il tuo Prep allo studio per un aiuto negli altri corsi',
  'channel.relatedBundle': 'Utilizza il tuo Prep allo studio anche per un aiuto negli altri corsi',
  'onboard.courseAdded': 'Corso aggiunto!',
  'hero.flashcards': 'Flashcard',
  'relatedChannelCard.title': 'Migliora il tuo apprendimento con questa risorsa correlata',
  'relatedChannelCard.badgeText': 'Correlato a Prep allo studio',
  'sessionInactivity.title': 'Ci sei ancora?',
  'sessionInactivity.description': 'La sessione scadrà tra <b>{TIMER}</b> per inattività.<br/>Vuoi mantenere l\'accesso?',
  'sessionInactivity.keepMeSignIn': 'Mantieni l\'accesso',
  'sessionInactivity.signOut': 'Disconnetti',
  'sessionTimeout.title': 'Sessione scaduta',
  'sessionTimeout.description': 'La sessione è scaduta per inattività.',
  'print.qrCode.header': 'Utilizza questo codice QR per aprire l\'app Pearson+ sul tuo dispositivo mobile.',
  'print.qrCode.footer': 'Scansiona il codice per visitare l\'App store e Google Play. Una volta installata l\'app, accedi per scaricarla e accedere al tuo titolo.',
  'hero.nestest.title': 'Preparati per il tuo esame di licenza all’insegnamento',
  'hero.nestest.subTitle': 'Gli utenti di Pearson+ possono ora accedere a corsi di preparazione e test di pratica conformi agli standard nazionali per prepararsi agli esami di abilitazione all\'insegnamento.',
  'hero.channelAI.title': 'Hai bisogno di aiuto? Tutor AI ti copre le spalle.',
  'hero.channelAI.desc': 'Rivolgi una domanda e ottieni aiuto per i compiti passo-passo, consigli di studio e altro ancora - aiuto personalizzato ogni volta che ti serve.',
  'hero.channelAI.action': 'Chiedi ora a Tutor AI',
  'new': 'Novità!',
  'hero.practice.numOfUsers': 'Questa sezione ha <b>{practice_num_of_users}</b> problemi di esercitazione.',
  'hero.practice.cta': 'Esercitati adesso',
  'hero.practice.title': 'Problema pratico',
  'diagnostics.errorMsg': 'Caricamento della diagnostica non riuscito. Chiudi e riprova.',
  'qrcode.title': 'Inizia a studiare ovunque',
  'qrcode.subtitle': 'Impara ovunque, in qualsiasi momento con l’app mobile Pearson+. Scarica ora e sblocca un’esperienza di apprendimento senza interruzioni.',
  'qrcode.detailsv1': 'Con l\'app Pearson+, puoi utilizzare questo codice QR per riprendere da dove avevi interrotto. Cerca nel tuo libro, studia con le schede didattiche, guarda le videolezioni e molto altro, ovunque tu sia.',
  'qrcode.detailsv2': 'Scansiona questo codice QR ogni volta che desideri accedere rapidamente e riprendere da dove avevi interrotto.',
  'qrcode.details': 'Con l\'app Pearson+, puoi utilizzare questo codice QR per riprendere da dove avevi interrotto.',
  'qrcode.appstore': 'App Store',
  'qrcode.playstore': 'Google Play',
  'nativePromoBanner.description': 'Impara ovunque, in qualsiasi momento con l’app mobile Pearson+. Scarica ora e sblocca un’esperienza di apprendimento senza interruzioni.',
  'install': 'Install',
  'header.menu.createCourse': 'Nuovo corso',
  'header.dropdown.courses': 'Corsi',
  'header.dropdown.recentlyViewed': 'Visualizzazioni recenti',
  'header.dropdown.viewAll': 'Visualizza tutti i corsi',
  'aet.courseHeader.inviteStudents': 'Invita gli studenti',
  'aet.courseHeader.inviteStudentModal.subTitle': 'Invita gli studenti ad accedere a questo libro di testo elettronico copiando l\'indirizzo del link o le istruzioni riportate di seguito nella tua email o nel programma del corso.',
  'aet.courseHeader.inviteStudentModal.linkAddress': 'Indirizzo link',
  'aet.courseHeader.inviteStudentModal.copyLink': 'Copia link',
  'aet.courseHeader.inviteStudentModal.instructionsTitle': 'Istruzioni con indirizzo link',
  'aet.courseHeader.inviteStudentModal.copyInstructions': 'Copia istruzioni',
  'aet.courseHeader.inviteStudentModal.instructionIntro': 'È tempo di accedere a {bookTitle} i libri eText per {courseName}.\n\n',
  'aet.courseHeader.inviteStudentModal.instructionAccessLink': 'Quando sei pronto, accedi ai tuoi libri eText su: {enrollmentLink}\n\n',
  'aet.courseHeader.inviteStudentModal.instructionSignIn': 'Ti verrà chiesto di accedere con il tuo account Pearson esistente. Se non hai un account Pearson, potrai crearne uno.\n\n',
  'aet.courseHeader.inviteStudentModal.instructionHelp': 'Serve aiuto?',
  'aet.courseHeader.inviteStudentModal.instructionHelpLink': 'AskPearson',
  'aet.courseHeader.startDate': 'Data inizio:',
  'aet.courseHeader.endDate': 'Data fine:',
  'aet.courseHeader.entitlement': 'Entitlement:',
  'aet.courseHeader.format': 'Formato:',
  'aet.home.manageroster': 'Gestisci l\'elenco',
  'aet.home.managegradesync': 'Gestisci la sincronizzazione dei voti',
  'aet.home.copycourse': 'Copia corso',
  'aet.home.unlinkcourse': 'Unlink course',
  'aet.tempAccess.warningBannerMessage': 'Temporary access expires on {date}',
  'aet.tempAccess.alertBannerMessage': 'Temporary access ends in {days} days. Upgrade to avoid interruptions.',
  'aet.tempAccess.upgradeAccessLabel': 'Upgrade access',
  'aet.tempAccess.expiredTitle': 'Temporary access has expired',
  'aet.tempAccess.expiredWithActionDescription': 'Your progress has been saved. Upgrade your access now to continue where you left off.',
  'aet.tempAccess.manageRoster.bannerMessage': 'One or more students have temporary access that has expired or may expire before all assignments are due.',
  'aet.tempAccess.manageRoster.emailActionLabel': 'Get student emails and access instructions',
  'aet.tempAccess.manageRoster.email.title': 'Student emails and access instructions',
  'aet.tempAccess.manageRoster.email.subTitle': 'Help students maintain access to their eTextbook by sharing the following instructions',
  'aet.tempAccess.manageRoster.email.recipientsLabel': 'Affected student email addresses',
  'aet.tempAccess.manageRoster.email.instructionsLabel': 'Access instructions',
  'aet.tempAccess.manageRoster.email.greeting': 'Dear Student,',
  'aet.tempAccess.manageRoster.email.paragraph1': 'Your temporary access for {courseName} may no longer be active. To maintain access to your eTextbook and your reading assignments, upgrade your access as soon as possible.',
  'aet.tempAccess.manageRoster.email.paragraph2': 'Once you\'ve accessed your course, you should see a prompt to upgrade. If not, follow these steps:',
  'aet.tempAccess.manageRoster.email.bullet1': 'Go to my account by selecting the circle with your initials in the upper right',
  'aet.tempAccess.manageRoster.email.bullet2': 'Go to Manage subscription',
  'aet.tempAccess.manageRoster.email.bullet3': 'Look for your eTextbook and follow the prompts to upgrade your access',
  'aet.tempAccess.manageRoster.email.footerPrefix': 'You can find detailed directions for how to upgrade, including a video walkthrough here: ',

  'aet.instructorCourse.tabs.current': 'Attuale',
  'aet.instructorCourse.tabs.past': 'Passato',
  'aet.instructorCourse.tabs.courseSettings': 'Impostazioni corso',
  'aet.instructorCourse.tabs.assignmentSettings': 'Assignment settings',
  'aet.instructorCourse.assignmentSettings.lmsAlertMessage': 'Important: Your LMS may also have assignment scoring settings. Changes in both places are applied together. To avoid unintended changes to final scoring, update settings in one place.',
  'aet.instructorCourse.assignmentSettings.gradebookSectionTitle': 'Display assignment scores in gradebook as',
  'aet.instructorCourse.assignmentSettings.gradebookInfoButtonAriaLabel': 'Learn about raw score and equal weighting',
  'aet.instructorCourse.assignmentSettings.rawScoreTitle': 'Raw score',
  'aet.instructorCourse.assignmentSettings.rawScoreDescription': 'Assignment scores vary based on the number of questions in each assignment.',
  'aet.instructorCourse.assignmentSettings.equalWeightingTitle': 'Equal weighting',
  'aet.instructorCourse.assignmentSettings.equalWeightingDescription': 'All assignments have the same base value.',
  'aet.instructorCourse.assignmentSettings.baseValueLabel': 'Base value:',
  'aet.instructorCourse.assignmentSettings.availabilitySectionTitle': 'Assignment availability',
  'aet.instructorCourse.assignmentSettings.availabilityFieldLabel': 'Assignments are available to students',
  'aet.instructorCourse.assignmentSettings.dueDatesSectionTitle': 'Scheduling defaults',
  'aet.instructorCourse.assignmentSettings.defaultDueTimeLabel': 'Default due time',
  'aet.instructorCourse.assignmentSettings.courseTimeZoneLabel': 'Course time zone',
  'aet.instructorCourse.assignmentSettings.cancelButtonLabel': 'Cancel',
  'aet.instructorCourse.assignmentSettings.saveButtonLabel': 'Save changes',
  'aet.instructorCourse.assignmentSettings.gradebookInfoModalTitle': 'Raw Score vs Equal Weighting',
  'aet.instructorCourse.assignmentSettings.gradebookInfoRawScoreHeading': 'Raw Score:',
  'aet.instructorCourse.assignmentSettings.gradebookInfoRawScoreBody': 'Grades reflect total points earned out of total points possible across all assignments. Longer or higher-point assignments naturally impact the final grade more.',
  'aet.instructorCourse.assignmentSettings.gradebookInfoEqualWeightingHeading': 'Equal Weighting:',
  'aet.instructorCourse.assignmentSettings.gradebookInfoEqualWeightingBody': 'Every assignment is normalized using a consistent base value so that each task contributes equally to the final grade, regardless of length or point total.',
  'aet.instructorCourse.assignmentSettings.baseValueRequired': 'Base value is required',
  'aet.instructorCourse.assignmentSettings.baseValueInvalid': 'Enter a value between 1 and 100',
  'aet.instructorCourse.assignmentSettings.availability.immediate': 'Immediately upon publish',
  'aet.instructorCourse.assignmentSettings.availability.fourWeeksBefore': '4 weeks before due date',
  'aet.instructorCourse.assignmentSettings.availability.twoWeeksBefore': '2 weeks before due date',
  'aet.instructorCourse.assignmentSettings.availability.oneWeekBefore': '1 week before due date',
  'aet.instructorCourse.tabs.manageRoster': 'Gestisci l\'elenco',
  'aet.instructorCourse.currentCourses.title': 'Corsi attuali',
  'aet.instructorCourse.pastCourses.title': 'Corsi passati',
  'aet.instructorCourse.createOrCopy.title': 'Crea o copia un corso per i libri eText Pearson',
  'aet.instructorCourse.createOrCopy.sectionTitle': 'Copia il corso di un altro istruttore o creane uno nuovo',
  'aet.instructorCourse.createOrCopy.copyPanel.title': 'Copia il corso di un altro istruttore',
  'aet.instructorCourse.createOrCopy.copyPanel.subtitle': 'Inserisci l’ID del corso per trovare il corso che intendi copiare.',
  'aet.instructorCourse.createOrCopy.copyPanel.courseIdLabel': 'ID corso',
  'aet.instructorCourse.createOrCopy.copyPanel.courseIdPlaceholder': 'Inserisci ID corso',
  'aet.instructorCourse.createOrCopy.copyPanel.searchedForPrefix': 'Hai cercato',
  'aet.instructorCourse.createOrCopy.catalogPanel.title': 'Crea un nuovo corso dal catalogo',
  'aet.instructorCourse.createOrCopy.catalogPanel.subtitle': 'Ricerca per titolo, autore, ISBN o argomento come parole chiave.',
  'aet.instructorCourse.createOrCopy.catalogPanel.searchPlaceholder': 'Ricerca in corso...',
  'aet.instructorCourse.createOrCopy.showMoreLabel': 'Mostra di più',
  'aet.instructorCourse.createOrCopy.showLessLabel': 'Mostra di meno',
  'aet.instructorCourse.cancel': 'Annulla',
  'aet.instructorCourse.loading': 'In caricamento...',
  'aet.instructorCourse.courseForm.copyError': 'Your course cannot be copied because the title is no longer supported. Please contact your Pearson representative or customer support.',
  'aet.instructorCourse.courseForm.gradeSync': 'Sincronizzazione dei voti',
  'aet.instructorCourse.courseForm.gradeSyncLinkLabel': 'Gestisci la sincronizzazione dei voti',
  'aet.instructorCourse.courseForm.courseNameLabel': 'Nome corso',
  'aet.instructorCourse.courseForm.courseNamePlaceholder': 'Senza titolo',
  'aet.instructorCourse.courseForm.sectionNameLabel': 'Nome sezione',
  'aet.instructorCourse.courseForm.sectionNamePlaceholder': 'Senza titolo',
  'aet.instructorCourse.courseForm.institutionFieldLabel': 'Istituto',
  'aet.instructorCourse.courseForm.institutionSelectLabel': 'Select an Institution',
  'aet.instructorCourse.courseForm.institutionPlaceholder': 'Start typing your institution',
  'aet.instructorCourse.courseForm.institutionRequiredError': 'L\'istituto è obbligatorio',
  'aet.instructorCourse.courseForm.institutionSearchError': 'Qualcosa non è andato a buon fine. Riprova per favore.',
  'aet.instructorCourse.courseForm.institutionNoResults': 'La ricerca non ha prodotto alcun risultato',
  'aet.instructorCourse.courseForm.findAnotherInstitutionLabel': 'Find another institution',
  'aet.instructorCourse.courseForm.higherEducationSectionLabel': 'Higher Education:',
  'aet.instructorCourse.courseForm.k12InstitutionsSectionLabel': 'K12 Institutions:',
  'aet.instructorCourse.courseForm.k12InstitutionsDescription': 'Go to your My Courses dashboard to create courses for this type of institution',
  'aet.instructorCourse.courseForm.createK12CourseLabel': 'Create K-12 course',
  'aet.instructorCourse.courseForm.k12EmptyStateHeadline': 'Creating a K–12 course?',
  'aet.instructorCourse.courseForm.k12EmptyStateDescription': 'You\'ll have to create it outside Pearson+. After that\'s complete, you\'ll be able to manage it here.',
  'aet.instructorCourse.courseForm.startDateLabel': 'Data inizio corso',
  'aet.instructorCourse.courseForm.endDateLabel': 'Data di fine corso',
  'aet.instructorCourse.courseForm.datePlaceholder': 'gg/mm/aa',
  'aet.instructorCourse.courseForm.allowCopyLabel': 'Consenti agli altri di copiare questo corso',
  'aet.instructorCourse.courseForm.shareCodeLabel': 'Condividi questo codice con gli istruttori che desiderano copiare questo corso',
  'aet.instructorCourse.courseForm.copyCodeLabel': 'Copia codice',
  'aet.instructorCourse.courseForm.optionalSuffix': '(opzionale)',
  'aet.instructorCourse.courseForm.formValidationLiveRegion': 'Il modulo ha errori di convalida',
  'aet.instructorCourse.courseForm.submitContinue': 'Prosegui',
  'aet.instructorCourse.courseForm.submitContinueLoading': 'Salvataggio in corso...',
  'aet.instructorCourse.courseForm.submitError': 'Non possiamo creare il corso. Riprova.',
  'aet.instructorCourse.courseForm.submitEditError': 'Non possiamo salvare le modifiche. Riprova.',
  'aet.instructorCourse.courseForm.submitSaveChanges': 'Salva modifiche',
  'aet.instructorCourse.courseForm.materialsHeader': 'Materiali del corso',
  'aet.instructorCourse.courseForm.resolveError': 'Non possiamo caricare i materiali del corso. Riprova.',
  'aet.instructorCourse.courseForm.copySourceError': 'We could not load the course to copy. Please search again from Create or copy course.',
  'aet.instructorCourse.coursesSort.lastViewed': 'Ultima visualizzazione',
  'aet.instructorCourse.coursesSort.recentlyAdded': 'Aggiunti recentemente',
  'aet.instructorCourse.coursesSort.aToZ': 'Da A a Z',
  'aet.instructorCourse.coursesSort.zToA': 'Da Z ad A',
  'aet.instructorCourse.manageRoster.column.name': 'Nome',
  'aet.instructorCourse.manageRoster.column.role': 'Ruolo',
  'aet.instructorCourse.manageRoster.column.email': 'Email',
  'aet.instructorCourse.manageRoster.column.access': 'eTextbook Access',
  'aet.instructorCourse.manageRoster.column.status': 'Stato',
  'aet.instructorCourse.manageRoster.enrolledDate': 'Iscritto {date}',
  'aet.instructorCourse.manageRoster.enrolledLabel': 'Enrolled:',
  'aet.instructorCourse.manageRoster.changeTo': 'Change to:',
  'aet.instructorCourse.manageRoster.access.expired': 'Expired',
  'aet.instructorCourse.manageRoster.access.tempAccessDays': '{days}-day temp access',
  'aet.instructorCourse.manageRoster.notAvailable': '---',
  'aet.instructorCourse.manageRoster.access.active': 'Active',
  'aet.instructorCourse.manageRoster.access.inactive': 'Inactive',
  'aet.instructorCourse.manageRoster.access.tempAccess': 'Temporary',
  'aet.instructorCourse.roster.role.student': 'Studente',
  'aet.instructorCourse.roster.role.ta': 'TA',
  'aet.instructorCourse.roster.role.instructor': 'Istruttore',
  'aet.instructorCourse.roster.status.active': 'Volumi disponibili',
  'aet.instructorCourse.roster.status.inactive': 'Inattivo',
  'aet.instructorCourse.manageRoster.filter.allMembers': 'Tutti i membri',
  'aet.instructorCourse.manageRoster.filter.activeStudents': 'Studenti attivi',
  'aet.instructorCourse.manageRoster.filter.inactiveStudents': 'Studenti inattivi',
  'aet.instructorCourse.manageRoster.filter.teachingAssistant': 'Assistente all’insegnamento',
  'aet.instructorCourse.manageRoster.filter.instructor': 'Istruttore',
  'aet.instructorCourse.courseForm.materialsAuthorLabel': 'Autore:',
  'aet.instructorCourse.courseForm.materialsIsbnLabel': 'ISBN:',
  'aet.instructorCourse.courseForm.materialsCreationDateLabel': 'Data di creazione del corso:',
  'aet.instructorCourse.noCoursesFound': 'Nessun corso trovato',
  'aet.instructorCourse.backButton': 'Indietro',
  'aet.instructorCourse.selectCourse': 'Seleziona corso',
  'aet.home.linkedToLms': 'Collegato a LMS',
  'aet.instructorCourse.courseForm.title.create': 'Crea un corso',
  'aet.instructorCourse.courseForm.title.copy': 'Copia corso',
  'aet.instructorCourse.courseForm.title.edit': 'Informazioni sul corso',
  'aet.instructorCourse.courseForm.copiedContentAccordion.assignments.title': 'Assegnazioni',
  'aet.instructorCourse.courseForm.copiedContentAccordion.assignments.content': 'Contenuto assegnazione',
  'aet.instructorCourse.courseForm.copiedContentAccordion.assignments.dueDates': 'Scadenze assegnazione',
  'aet.instructorCourse.courseForm.copiedContentAccordion.highlightsAndNotes.title': 'Evidenziazioni e note',
  'aet.instructorCourse.courseForm.copiedContentAccordion.highlightsAndNotes.highlightColor': 'Evidenzia colore',
  'aet.instructorCourse.courseForm.copiedContentAccordion.highlightsAndNotes.noteText': 'Nota di testo',
  'aet.instructorCourse.courseForm.copiedContentAccordion.highlightsAndNotes.sharedStatus': 'Stato condiviso',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.title': 'Elenco e impegno degli studenti',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.studentNames': 'Nomi degli studenti',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.emailAddresses': 'Indirizzi e-mail',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.enrollments': 'Iscrizioni',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.completionAndInsights': 'Completamento e analisi',
  'aet.instructorCourse.courseForm.copiedContentAccordion.settings.title': 'Impostazioni',
  'aet.instructorCourse.courseForm.copiedContentAccordion.settings.aiToolEnablement': 'AI Tool enablement',
  'aet.instructorCourse.courseForm.copyAccordionTitle': 'Show what’s copied',
  'aet.instructorCourse.courseForm.copyAccordionSubTitle': 'Dati copiati',
  'aet.studentRoster.manageStudentRosterButton': 'Gestisci l’elenco studenti',
  'aet.studentRoster.dontHaveAnyStudent': 'Looks like you don’t have any students.',
  'aet.studentRoster.lmsEmptyState.title': 'No students have accessed the course yet',
  'aet.studentRoster.lmsEmptyState.description': 'As soon as students click through from your LMS, you’ll see their names and progress here.',
  'aet.studentRoster.nonlmsEmptyState.description': 'As soon as students join your course, you’ll see their names and progress here.',
  'aet.syllabus.editContentDisabledTooltip': 'Cannot update assignment while student work is in progress.',
  'aet.assignments.exportStudentProgressButton': 'Esporta progressi studente',
  'aet.home.student.roaster.enrolmentInformationTitle': 'Enrolment information',
  'aet.home.student.roaster.enrolmentInformation.status': 'Stato:',
  'aet.home.student.roaster.enrolmentInformation.enrolled': 'Iscritto:',
  'aet.home.student.roaster.enrolmentInformation.access': 'Access:',
  'aet.home.student.roaster.enrolmentInformation.role': 'Ruolo:',
  'aet.home.student.roaster.enrolmentInformation.promotionCardTitle': 'Promuovi {studentName}?',
  'aet.home.student.roaster.enrolmentInformation.promotionCardContent1': 'In qualità di assistente didattico, questa persona potrà osservare i progressi e il rendimento di tutti gli studenti della classe.',
  'aet.home.student.roaster.enrolmentInformation.promotionCardContent2': 'Potranno inoltre gestire studenti e compiti, ma non potranno eliminare la classe.',
  'aet.home.student.roaster.enrolmentInformation.promotionCardConfirmLabel': 'Promuovi per l’assistente all’insegnamento',
  'aet.home.manageRoster.searchPlaceholder': 'Ricerca per studente',
  'aet.home.manageRoster.inactivateButtonLabel': 'Disattiva studenti selezionati',
  'aet.home.manageRoster.FilterLabel': 'Mostra',
  'aet.home.manageRoster.updatingMessage': 'Aggiornamento elenco in corso... Questo potrebbe impiegare alcuni minuti.',
  'aet.home.courses.search.searchPlaceHolder': 'Cerca i tuoi corsi',
  'aet.courses.emptyStateDescription': 'Inizia a costruire il tuo corso scegliendo un opzione in basso.',
  'nativePromoBanner.continueInBrowser': 'Continua nel browser',
  'globalnav.tooltip.hideNavText': 'Nascondi navigazione',
  'globalnav.tooltip.showNavText': 'Mostra navigazione',
  'aet.syllabus.progressTitle': 'Estrazione in corso...',
  'aet.syllabus.progressDesc': 'Attendere l’elaborazione del programma.',
  'aet.syllabus.uploadInputLabel': 'Trascina i file qui o clicca per caricare',
  'aet.syllabus.uploadSyllabusTabLabel': 'Carica il programma scolastico',
  'aet.syllabus.dateAdjusterTabLabel': 'Regolatore data',
  'aet.syllabus.addManuallyTabLabel': 'Aggiungi assegnazioni manualmente',
  'aet.syllabus.addEditLaterText': 'Puoi sempre aggiungere e modificare le assegnazioni in seguito',
  'aet.syllabus.editAssignmentLabel': 'Modifica assegnazione',
  'aet.syllabus.addAssignmentLabel': 'Aggiungi assegnazione',
  'aet.syllabus.assignmentTitleLabel': 'Titolo assegnazione:',
  'aet.syllabus.assignmentTitleAutoPlaceholder': 'Automatically generated',
  'aet.syllabus.dueDateLabel': 'Data di scadenza',
  'aet.syllabus.editDueDateLabel': 'Modifica data di scadenza',
  'aet.syllabus.chaptersCoveredLabel': 'Seleziona i capitoli o le sezioni da coprire.',
  'aet.syllabus.updateCtaLabel': 'Aggiorna assegnazione',
  'aet.syllabus.addCtaLabel': 'Aggiungi assegnazione',
  'aet.syllabus.uploadLabel': 'Carica',
  'aet.syllabus.confirmLabel': 'Conferma',
  'aet.syllabus.addContentLabel': 'Aggiungi contenuti',
  'aet.syllabus.addEditContentLabel': 'Aggiungi/modifica contenuti',
  'aet.syllabus.notPublishedLabel': 'Non pubblicato',
  'aet.syllabus.updateDatesLabel': 'Aggiorna data',
  'aet.syllabus.dateNormalization.yearAdjustedContentSingle': 'La data di scadenza è stata aggiornata. Rivedila e poi pubblicala.',
  'aet.syllabus.coverageDedupe.adjustedContent': 'Le informazioni relative al tuo capitolo/sezione sono state aggiornate. Rivedile e poi pubblicale.',
  'aet.syllabus.unassignedCoverageStatus': 'Alcuni capitoli non sono ancora stati assegnati. Assegnateli prima di pubblicare.',
  'aet.syllabus.dateNormalization.manualEntryContent': 'Add a due date before you publish.',
  'aet.syllabus.pastDuePublishStatus': 'Update due date before you publish.',
  'aet.deleteAssignmentTitle': 'Elimina assegnazione?',
  'aet.deleteAssignmentTitleMultiple': 'Elimina assegnazioni?',
  'aet.deleteAssignmentWarning': 'Quest’azione non può essere cancellata e tutti gli invii associati e i dati degli studenti non saranno più visibili.',
  'aet.deleteAssignmentKeepCTA': 'Conserva l’assegnazione',
  'aet.deleteAssignmentDeleteCTA': 'ELIMINA',
  'aet.assignments.loadingAsset': 'Caricamento in corso asset...',
  'aet.assignments.addToDate': 'Aggiungi a data',
  'aet.assignments.previewAsStudent': 'Anteprima come studente',
  'aet.assignments.questionsAndTopics': 'Domande e argomenti',
  'aet.assignments.questionsAndTopicsModal.doneLabel': 'Fatto',
  'aet.assignments.questionsAndTopicsModal.dueDateLabel': 'Data di scadenza',
  'aet.assignments.questionsAndTopicsModal.questionsTotalLabel': 'Domande totali',
  'aet.assignments.questionsAndTopicsModal.questionOfTotalLabel': 'Domande {count} di {total}',
  'aet.assignments.publishToStudents': 'Pubblica per gli studenti:',
  'aet.assignments.availableToStudentsOn': 'Available to students on {0}',
  'aet.syllabus.addDateLabel': 'Aggiungi data',
  'aet.doneLabel': 'Fatto',
  'aet.assignments.dueDateLabel': 'Scadenza assegnazione',
  'aet.assignmentNameLabel': 'Assignment name',
  'aet.assignment.nameDisabledPlaceholder': 'Add content to generate a default name for your assignment',
  'aet.assignment.nameGeneratedPlaceholder': 'Automatically generated assignment name based on selected content',
  'aet.onboarding.getStarted.title': 'Get started creating assignments now',
  'aet.onboarding.getStarted.manualSetup.title': 'Configurazione manuale',
  'aet.onboarding.getStarted.manualSetup.description': 'Create and customize individual reading assignments and set their due dates',
  'aet.onboarding.getStarted.assistedScheduling.title': 'Assisted scheduling',
  'aet.onboarding.getStarted.assistedScheduling.description': 'Automatically set all due dates and easily add chapter content from your eTextbook',
  'aet.onboarding.getStarted.autoCreateAssignments.title': 'Auto-create assignments',
  'aet.onboarding.getStarted.autoCreateAssignments.description': 'Upload your syllabus to generate all reading assignments in seconds',
  'aet.onboarding.promotion.title': 'Hold students accountable with assigned reading',
  'aet.onboarding.promotion.feature.1': 'Create multiple assignments within minutes, with optional grade sync to your LMS',
  'aet.onboarding.promotion.feature.2': 'Utilizza approfondimenti in tempo reale per individuare le lacune di apprendimento, in modo da poter agire tempestivamente e con sicurezza',
  'aet.onboarding.promotion.feature.3': 'Gli studenti ricevono un supporto maggiore grazie al feedback mirato e all\'intelligenza artificiale integrata di Pearson.',
  'aet.assistedSchedule.pageTitle': 'Assisted scheduling',
  'aet.assistedSchedule.reviewPageTitle': 'Create your assignments',
  'aet.assistedSchedule.sectionTitle': 'Set a recurring assignment schedule',
  'aet.assistedSchedule.sectionDescription': 'We\'ll create assignment slots throughout your course that you can populate with content from your eTextbook.',
  'aet.assistedSchedule.dueDaysLabel': 'Due day(s)',
  'aet.assistedSchedule.dueDaysTip': 'Tip: Make assignments due 1 or 2 days before your class meets in order to get the most out of assignment insights',
  'aet.assistedSchedule.dueDaysPlaceholder': 'Choose',
  'aet.assistedSchedule.dueDaysRequiredError': 'Select at least one day',
  'aet.assistedSchedule.dueTimeRequiredError': 'Due time is required',
  'aet.assistedSchedule.timeZoneRequiredError': 'Time zone is required',
  'aet.assistedSchedule.startDateLabel': 'Starts on',
  'aet.assistedSchedule.endDateLabel': 'Ends on',
  'aet.assistedSchedule.datePlaceholder': 'mm/dd/yyyy',
  'aet.assistedSchedule.startDateRequiredError': 'Start date is required',
  'aet.assistedSchedule.endDateRequiredError': 'End date is required',
  'aet.assistedSchedule.scheduleInstruction': 'Drag content into the assignment slots to build your schedule.',
  'aet.assistedSchedule.dragZoneLabel': 'Drag content here to assign it to students',
  'aet.assistedSchedule.clickToEditLabel': 'Click to edit',
  'aet.assistedSchedule.clearDataLabel': 'Clear data',
  'aet.assistedSchedule.formValidationLiveRegion': 'Form has validation errors',
  'aet.assistedSchedule.noQuestionsError': 'Each assignment must include content with at least one question.',
  'aet.assistedSchedule.noQuestionsWarningLabel': 'Add content with at least 1 question to save this assignment.',
  'aet.assistedSchedule.noAssignmentsModalTitle': 'No assignments can be created',
  'aet.assistedSchedule.noAssignmentsModalMessage': 'The selected date range is too short to generate any assignments. Extend the date range and try again.',
  'aet.assignments.allCaughtUpDescription': 'Non ci sono assegnazioni questa settimana',
  'aet.assignments.progressTitle': 'Progresso',
  'aet.assignments.performanceTitle': 'Sicurezza',
  'aet.assignments.completionTitle': 'Completamento',
  'aet.assignments.statusTitle': 'Stato',
  'aet.assignments.addTooltip': 'Aggiungi assegnazione',
  'aet.assignments.deleteTooltip': 'Elimina assegnazioni selezionate',
  'aet.assignments.selectToDeleteLabel': 'Modalità selezione ed elimina',
  'aet.assignments.bulkEditTooltip': 'Modifica assegnazioni in massa',
  'aet.assignments.title': 'Assegnazioni',
  'aet.assignments.assignmentTitle': 'Assegnazione',
  'aet.assignments.dueDate': 'Data di scadenza',
  'aet.tabular.searchPlaceholder.assignments': 'Ricerca per assegnazione',
  'aet.tabular.searchPlaceholder.students': 'Ricerca studenti',
  'aet.tabular.searchPlaceholder.questions': 'Ricerca domande',
  'aet.assignemnts.columnDueDateInfoTooltip': 'Uno o più studenti hanno estensioni delle scadenze per tutte le assegnazioni',
  'aet.assignemnts.singleDueDateInfoTooltip': 'Uno o più studenti hanno estensioni delle scadenze per quest’assegnazione',
  'aet.assignemnts.masterDueDateInfoTooltip': 'A uno o più studenti sono stati garantiti posticipi delle date di scadenza. Guarda l’icona Info per identificare queste assegnazioni.',
  'aet.home.loading': 'In caricamento...',
  'aet.home.errorFetchingAssignments': 'Errore fetching assegnazioni',
  'aet.home.dueThisWeekTitle': 'In scadenza questa settimana',
  'aet.home.allCaughtUpTitle': 'Ti sei messo in pari!',
  'aet.home.allCaughtUpDescription': 'Non ci sono assegnazioni questa settimana',
  'aet.home.suggestedRemediationTitle': 'Revisione suggerita da Prep allo studio',
  'aet.home.noSuggestedRemediationTitle': 'Nessun materiale di revisione suggerito',
  'aet.home.noSuggestedRemediationDescription': 'Ricontrolla dopo la tua prossima assegnazione.',
  'aet.home.assignmentIncludesTitle': 'L’assegnazione include',
  'aet.home.sectionsLabel': 'capitolo(i)',
  'aet.home.questionsCount': '{count} domande',
  'aet.home.dueLabel': 'Entro: {dueDate}',
  'aet.home.due': 'Entro:',
  'aet.home.progressCompletedLabel': 'Completato',
  'aet.home.progressCompletedPastDueLabel': 'Completato dopo la scadenza',
  'aet.home.progressInProgressLabel': 'In corso',
  'aet.home.progressPartiallyCompleteLabel': 'Partially complete',
  'aet.home.progressNotStartedLabel': 'Non iniziato',
  'aet.home.progressCountOfTotal': '{count} di {total}',
  'aet.home.NotAttemptedLabel': 'Non tentato',
  'aet.home.questionsTotalLabel': 'Domande totali',
  'aet.home.progressCompletedOnTimeLabel': 'Completato in tempo',
  'aet.home.segmentGreatLabel': 'Bene',
  'aet.home.segmentGettingThereLabel': 'OK',
  'aet.home.segmentNeedsReviewLabel': 'Bisogno di studio',
  'aet.home.segmentOkayLabel': 'OK',
  'aet.home.editAssignmentTooltip': 'Modifica assegnazione',
  'aet.home.deleteAssignmentTooltip': 'Elimina assegnazione',
  'aet.home.viewDetailsButton': 'Visualizza dettagli',
  'aet.home.viewAsStudentButton': 'Visualizza come studente',
  'aet.home.welcomeButtonText': 'Tieniti pronto per iniziare →',
  'aet.review.emptyStateTitle': 'Nulla da rivedere',
  'aet.review.emptyStateDescription': 'Ricontrolla dopo la tua prossima assegnazione.',
  'aet.dashboard.tabs.upNext': 'Vai avanti',
  'aet.dashboard.tabs.welcome': 'Benvenuto',
  'aet.dashboard.tabs.assignments': 'Assegnazioni',
  'aet.dashboard.tabs.review': 'Rivedi',
  'aet.dashboard.tabs.studentRoster': 'Studenti',
  'aet.dashboard.classSchedule': 'Programma della lezione:',
  'aet.syllabus.dueTimeLabel': 'Tempo massimo',
  'hero.accessEducatorGuides': 'Accesso guide insegnante',
  'aet.assignment.save': 'Salva',
  'aet.assignment.finish': 'Fine',
  'aet.assignment.saveAndAdd': 'Salva e aggiungi un altro',
  'aet.assignment.delete': 'ELIMINA',
  'aet.assignment.saveAndClose': 'Salva e chiudi',
  'aet.studentRoster.title': 'Studenti',
  'aet.studentRoster.titlev1': 'Studente',
  'aet.studentRoster.dueDatesAdjustmentLabel': 'Date di scadenza',
  'aet.studentRoster.dueDateAdjustment.option.0': 'Standard',
  'aet.studentRoster.dueDateAdjustment.option.2': '+2 giorni',
  'aet.studentRoster.dueDateAdjustment.option.3': '+3 giorni',
  'aet.studentRoster.dueDateAdjustment.option.5': '+5 giorni',
  'aet.studentRoster.dueDateAdjustment.option.week.1': '+1 settimana',
  'aet.studentRoster.dueDateAdjustment.option.week.2': '+2 settimane',
  'aet.studentRoster.dueDateAdjustment.option.lastDayOfClass': 'Ultimo giorno di lezione',
  'aet.studentRoster.dueDateAdjustment.toast.partial.title.multiple': '{count} assegnazioni aggiornate',
  'aet.studentRoster.dueDateAdjustment.toast.partial.message': 'Le assegnazioni scadute non possono essere aggiornate automaticamente. Modifica ognuna di esse per impostare una nuova data di scadenza.',
  'aet.studentRoster.dueDateAdjustment.toast.allPastDue.title': 'Impossibile aggiornare le date di scadenza',
  'aet.studentRoster.dueDateAdjustment.toast.allPastDue.message': 'Tutte le assegnazioni sono scadute e non possono essere aggiornate automaticamente. Modifica ognuna di esse per impostare una nuova data di scadenza.',
  'aet.bulkEdit.bulkSplitInstruction': 'Divideremo le tue assegnazioni equamente.',
  'aet.bulkEdit.Description': 'Figma ipsum component variant main layer. Editor library device auto star reesizing pencil horizontal. Polygon main list figjam star layout object connection hand scale.',
  'aet.bulkEdit.firstAssignmentDue': 'Scadenza prima assegnazione',
  'aet.bulkEdit.lastAssignmentDue': 'Scadenza ultima assegnazione',
  'aet.bulkEdit.assignmentsDueDays': 'Quali giorni desideri come scadenza delle assegnazioni?',
  'aet.bulkEdit.addEditLaterText': 'Usiamo l’IA per creare le assegnazioni. Puoi sempre aggiungere e modificare le assegnazioni in seguito.',
  'aet.bulkEdit.monday': 'Lunedì',
  'aet.bulkEdit.tuesday': 'Martedì',
  'aet.bulkEdit.wednesday': 'Mercoledì',
  'aet.bulkEdit.thursday': 'Giovedì',
  'aet.bulkEdit.friday': 'Venerdì',
  'aet.bulkEdit.saturday': 'Sabato',
  'aet.bulkEdit.sunday': 'Domenica',
  'aet.toast.assignmentCreated.title': 'Assegnazione creata!',
  'aet.toast.assignmentCreated.single': 'É nominata automaticamente {assignmentTitle}',
  'aet.toast.assignmentCreated.multiple': '{count} le assegnazioni sono state create',
  'aet.toast.assignmentUpdated.title': 'Aggiornamento avvenuto con successo',
  'aet.toast.assignmentUpdated.single': '{assignmentTitle} è stata aggiornata',
  'aet.toast.assignmentUpdated.multiple': '{count} le assegnazioni sono state aggiornate',
  'aet.toast.assignmentPublished.single': '{count} assignment successfully published!',
  'aet.toast.assignmentPublished.multiple': '{count} assignments successfully published!',
  'aet.toast.assignmentPublished.subtitle': 'I contenuti dell’assegnazione possono essere modificati fino a che gli studenti iniziano a lavorare.',
  'aet.toast.viewAssignment': 'Visualizza assegnazione',
  'aet.toast.viewAssignments': 'Visualizza assegnazioni',
  'aet.welcome.title': 'Il tuo libro eText Pearson ora è collegato al tuo corso LMS',
  'aet.welcome.LMSAccounTitle': 'Esplora le conoscenze',
  'aet.welcome.LMSAccounDescription': 'Vedi esattamente in quali argomenti la tua classe ha difficoltà.',
  'aet.welcome.createAssignmentsTitle': 'Crea assegnazioni',
  'aet.welcome.createAssignmentsDescription': 'Assegna capitoli manualmente o caricando il tuo programma',
  'aet.welcome.progressViewTitle': 'Traccia performance nel tuo LMS',
  'aet.welcome.progressViewDescription': 'Scegli il grado delle impostazioni di sincronizzazione nel tuo corso LMS.',
  'aet.assignmentDetails.noAssignmentFound': 'Nessun’assegnazione trovata',
  'aet.assignments.loadingErrorTitle': 'Impossibile caricare l’assegnazione in questo momento',
  'aet.assignments.loadingErrorDescription': 'Prova ad aggiornare o verificare di nuovo più tardi.',
  'aet.assignmentStudentDetails.noDataFound': 'Ancora nessuna nota',
  'aet.assignmentStudentDetails.noData': 'No data',
  'aet.studentRoster.noStudentsRegisteredYet': 'Nessun studente registrato',
  'aet.studentRoster.noStudentsRegisteredYetDescription': 'Gli studenti si uniranno alla tua classe quando acquisteranno i libri eText.',
  'aet.home.editAssignmentTooltipDisabled': 'Impossibile modificare: lavoro studente in corso',
  'aet.home.deleteAssignmentTooltipDisabled': 'Impossibile eliminare: lavoro studente in corso',
  'aet.home.StudentDetails.questions': 'Esercizi',
  'aet.home.StudentDetails.attempts': 'Tentativi',
  'aet.home.StudentDetails.comprehension': 'Sicurezza',
  'hero.titleInfo.tooltip': 'Informazioni sul titolo',
  'aet.home.publishAssignments': 'Pubblica tutte le assegnazioni',
  'aet.assignments.saveScheduleAsDraft': 'Salva il programma come bozza',
  'aet.assignments.reviewBeforePublishAlert': 'Rivedi le tue assegnazioni, quindi pubblica i tuoi compiti per renderli visibili agli studenti.',
  'aet.assignments.copiedCoursePublishAlert': 'Aggiungi le date per le assegnazioni copiate e pubblica per renderle visibili agli studenti.',
  'aet.assignments.allSetPublishAlert': 'Tutto pronto? Pubblica i tuoi compiti per renderli visibili agli studenti.',
  'aet.assignments.emptyStateTitle': 'No assignments yet',
  'aet.assignments.emptyStateDescription': 'Assignments you create will appear here',
  'aet.dashboard.footer': 'Alcuni contenuti creati utilizzando l\'IA basata sui materiali didattici Pearson. Sebbene Pearson abbia un processo per convalidare l\'output, l\'IA generativa potrebbe comunque produrre informazioni imprecise su persone, luoghi o fatti.',
  'aet.home.bulkEditTitle': 'Modifica assegnazioni in massa',
  'aet.home.bulkEditSubtitle': 'Apponi modifiche al tuo programma scolastico, quindi ricaricalo qui. Le tue assegnazioni e le scadenze saranno caricate in modo da combaciare.',
  'aet.home.createAssignmentTitle': 'Crea assegnazioni',
  'aet.assignments.includedInAnotherAssignmentTooltip': 'Incluso in un’altra assegnazione',
  'aet.assignments.someSectionsIncludedInAnotherAssignmentTooltip': 'Alcune assegnazioni sono incluse in un’altra assegnazione',
  'aet.welcome.welcome.Title': 'Benvenuto!',
  'aet.home.student.roaster.ProgressTitle': 'Completamento totale',
  'aet.assignmentStudentDetails.startAssignmentDescription': 'Verifica di nuovo una volta che gli studenti iniziano l’assegnazione.',
  'aet.home.whatDueThisWeekTitle': 'Ecco le scadenze della settimana',
  'aet.assignments.edit.errorTitle': '{count} le assegnazioni hanno errori',
  'aet.assignments.edit.errorSubTitle': 'Le assegnazioni con errori non possono essere pubblicato. Modificale o pubblicale senza errori.',
  'aet.assignments.edit.publishAnyway': 'Pubblica comunque',
  'aet.assignments.edit.editAssignments': 'Modifica assegnazioni',
  'aet.assignments.edit.validationInfoToolTip': 'Modifica assegnazioni per rimuovere errori',
  'aet.assignments.error.assignmentCreated.title': 'Tutte le assegnazioni hanno errori',
  'aet.assignments.error.assignmentCreated.description': 'Le assegnazioni con errori non possono essere pubblicato. Modificale o prova un programma diverso.',
  'aet.assignments.error.uploadSyllabus': 'Carica il programma scolastico',
  'aet.assignments.error.editAssignments': 'Modifica assegnazioni',
  'aet.mondly.title': 'Lingue',
  'aet.studentRoster.errorState.title': 'Elenco studenti non disponibile',
  'aet.studentRoster.errorState.description': 'Impossibile caricare il tuo elenco studenti. Prova ad aggiornare o verificare di nuovo più tardi.',
  'aet.assignments.sectionLabel': 'sezione(i)',
  'aet.assignments.sectionLabelCapitalized': 'Section(s):',
  'aet.assignments.sectionsPrefix': 'Sections:',
  'aet.assignments.chaptersPrefix': 'Chapters:',
  'aet.assignments.questionsLabel': 'domanda(e)',
  'aet.assignments.assignmentsLabel': 'assegnazione(i)',
  'aet.assignments.performanceProgressBar': 'Barra di progresso prestazione',
  'aet.assignments.completionProgressBar': 'Barra di progresso completamento',
  'aet.syllabus.deleteConfirmationSubtitleSingle': 'Vuoi davvero eliminare quest’assegnazione?',
  'aet.syllabus.deleteConfirmationSubtitleBulk': 'Vuoi davvero eliminare queste assegnazioni?',
  'aet.home.nextAssignmentTitle': 'Prossima assegnazione',
  'aet.home.courseSettings': 'Impostazioni corso',
  'aet.home.assignmentSettings': 'Assignment settings',
  'aet.home.pearsonETextbookResources': 'Risorse libri eText Pearson+',
  'aet.home.etextbookInformation': 'informazioni sui libri eText',
  'aet.multiple.deleteAssignmentKeepCTA': 'Conserva l(e) assegnazione(i)',
  'aet.syllabus.processingText.header': 'Stiamo organizzando le letture assegnate alla tua classe: ci vorrà solo un attimo.',
  'aet.syllabus.processingText.uploading': 'Caricamento del tuo documento',
  'aet.syllabus.processingText.activating': 'Attivazione dei componenti IA',
  'aet.syllabus.processingText.extracting': 'Estrazione della lettura dalle assegnazioni',
  'aet.syllabus.processingText.mapping': 'Mappatura del contenuto del libro di testo',
  'aet.syllabus.processingText.finishing': 'Rifinitura',
  'aet.syllabus.uploadErrorMessage': 'Assicurati che il tuo PDF o.docx sia inferiore a 10MB e che la tua connessione Internet sia stabile',
  'aet.syllabus.uploadNoAssignmentsMessage': 'Nessuna lettura assegnata trovata',
  'aet.syllabus.uploadNoAssignmentsDescription': 'Non è stato possibile estrarre le letture assegnate da questo file. Puoi aggiungerle manualmente.',
  'aet.syllabus.uploadFailedRetryCTA': 'Riprova',
  'aet.syllabus.uploadModal.noAssignments.title': 'Couldn\'t find assignments',
  'aet.syllabus.uploadModal.noAssignments.body1': 'We weren\'t able to find any reading assignments within the uploaded syllabus.',
  'aet.syllabus.uploadModal.noAssignments.body2': 'Verifica attentamente che il tuo programma di studi contenga <qualities a syllabus should have for this to work> e riprova, oppure passa alla creazione manuale dei compiti.',
  'aet.syllabus.uploadModal.noAssignments.manualCreationCTA': 'Creazione manuale',
  'aet.syllabus.uploadModal.noAssignments.backToUploadCTA': 'Back to upload',
  'aet.syllabus.uploadModal.genericFailure.title': 'Qualcosa è andato storto',
  'aet.syllabus.uploadModal.genericFailure.body1': 'Non siamo riusciti a caricare ed elaborare il programma.',
  'aet.syllabus.uploadModal.genericFailure.body2': 'Verifica la connessione e riprova, oppure passa alla creazione manuale dell\'assegnazione.',
  'aet.syllabus.uploadModal.successTotal.title': 'Pronto per la revisione',
  'aet.syllabus.uploadModal.successTotal.body1': 'We found {count} assignments from your syllabus.',
  'aet.syllabus.uploadModal.successTotal.body2': 'Make any adjustments, then save or publish when you\'re ready. You can continue making changes before students start working.',
  'aet.syllabus.uploadModal.successPartial.title': 'Pronto per la revisione',
  'aet.syllabus.uploadModal.successPartial.body1': 'We found {count} assignments from your syllabus.',
  'aet.syllabus.uploadModal.successPartial.body2': 'We couldn\'t find exact matches in the eTextbook for every item. Review your assignments to make any adjustments, then save or publish when you\'re ready.',
  'aet.syllabus.uploadModal.reviewAssignmentsCTA': 'Rivedi assegnazioni',
  'aet.syllabus.selectChapterWithQuestions': 'Seleziona un capitolo con domanda(e).',
  'preferenceSetting.subTitle': 'Queste impostazioni saranno predefinite per tutti gli studenti di questo corso.',
  'preferenceSetting.sections.isAIStudyEnabled.label': 'Interazioni IA',
  'preferenceSetting.sections.isAIStudyEnabled.subLabel': 'Abilita lo Strumento di studio AI e i riassunti AI nei risultati di ricerca',
  'preferenceSetting.sections.isStudyPrepEnabled.subLabel': 'Mostra le risorse Prep allo studio relative a questo libro',
  'aet.syllabus.footer': 'La creazione degli incarichi è alimentata dall’IA',
  'aet.dashboard.footerDialogDeatils': 'L’IA generativa viene utilizzata per creare domande di assegnazione basate sui materiali didattici Pearson. Sebbene Pearson disponga di un processo per convalidare l\'output, l’IA generativa potrebbe comunque produrre informazioni imprecise su persone, luoghi o fatti. L’IA viene utilizzata anche per raggruppare i contenuti in assegnazioni, in base al programma e/o al programma forniti.',
  'aet.review.footer': 'Creato usando l’IA',
  'aet.footerCard.dismiss': 'Annulla',
  'preferenceSetting.sections.isStudyPrepEnabled.descriptionText1': 'Prep allo studio è uno strumento aggiuntivo che supporta l\'apprendimento fornendo agli studenti video ed esercizi pratici pensati appositamente per questo corso.',
  'preferenceSetting.sections.isStudyPrepEnabled.descriptionText2': 'Agli studenti il cui piano di accesso non include Prep allo studio potrebbe essere chiesto di abbonarsi per continuare a utilizzare le risorse di Prep allo studio.',
  'preferenceSetting.sections.isStudyPrepEnabled.descriptionText3': 'Quest’impostazione non interesserà gli studenti che hanno già acquistato Prep allo studio.',
  'preferenceSetting.sections.isStudyPrepEnabled.helpLinkText': 'Potete ricevere ulteriori informazioni sui vantaggi di Prep allo studio',
  'aet.home.viewCourseId': 'Visualizza ID corso',
  'aet.home.copy': 'Copia',
  'aet.home.copied': 'Copiato',
  'aet.home.courseLabel': 'ID corso:',
  'schoolInfoCard.addUniversity': 'Aggiungi scuola',
  'schoolInfoCard.title': 'Informazioni scuola',
  'schoolInfoCard.titleV1': 'Raccontaci del tuo corso',
  'schoolInfoCard.cta': 'Tieniti pronto per iniziare',
  'schoolInfoCard.pickInstitution': 'Scegli scuola',
  'schoolInfoCard.addUniversityTitle': 'Aggiungi la tua scuola',
  'schoolInfoCard.addUniversitySubtitle': 'Conoscendo la tua scuola e il tuo corso di studi possiamo consigliarti i materiali di studio più utili.',
  'schoolInfoCard.searchPlaceholder': 'Cerca la tua scuola...',
  'schoolInfoCard.skip': 'Salta questo passaggio',
  'schoolInfoCard.nextStep': 'Prossimo passaggio',
  'schoolInfoCard.notInList': 'La mia scuola non è in elenco',
  'schoolInfoCard.noResults': 'Nessuna scuola trovata corrispondente alla tua ricerca',
  'schoolInfoCard.noResultsHeading': 'Non riesci a trovare la tua scuola?',
  'schoolInfoCard.noResultsInstruction': 'Inserisci il nome completo in basso',
  'schoolInfoCard.noResultsInputPlaceholder': 'Nome della scuola',
  'schoolInfoCard.addInstitutionLabel': 'Aggiungi questa scuola',
  'aet.assignments.assignmentTitlePlaceholder': 'Inserisci un titolo',
  'aet.assignments.titleValidation.titleRequired': 'Il titolo dell’assegnazione è obbligatorio.',
  'aet.assignments.titleValidation.titleTooLong': 'L’assegnazione non può superare {0} caratteri.',
  'aet.assignments.titleValidation.titleInvalidChar': 'Il titolo dell’assegnazione contiene caratteri non supportati.',
  'aet.assignments.titleValidation.titleDuplicate': 'Il titolo dell’assegnazione esiste già.',
  'aet.syllabus.timeZoneLabel': 'Fuso orario',
  'aet.review.reviewReadingFromAssignments': 'Rivedi lettura da assegnazione',
  'aet.assignments.chaptersLabel': 'capitolo(i)',
  'menu.myAccount.subTitle': 'Il tuo istituto vive qui',
  'menu.myAccount.subTitleNotAvailable': 'Puoi aggiungere l’istituto qui in seguito in qualsiasi momento.',
  'schoolInfoCard.toastMessage': 'Università salvata',
  'aet.review.threeDotMenu.askAI': 'Chiedi all’IA',
  'aet.home.suggestedRemediationSubtitle': 'Guarda i video rilevanti e le prove per padroneggiare gli argomenti del tuo corso.',
  'aet.home.laggedQuestionLabel': 'Domande segnalate',
  'aet.home.correctAnswer': 'Risposta corretta',
  'aet.home.incorrectAnswer': 'Risposta scorretta più comune',
  'aet.home.behaviourTrendsLabel': 'Approfondimenti Domanda',
  'aet.home.strugglingStudentsLabel': 'Studenti in difficoltà',
  'aet.home.patternsInStudensAiLabel': 'Motivi nell’uso dell’AI dello studente',
  'aet.home.questionLabel': 'Domanda',
  'aet.home.studentAskingSimilarQuestions': 'Studenti che fanno domande simili',
  'aet.home.assignmentDifficultQuestions': 'Domande difficili',
  'aet.home.behaviorTrends': 'Approfondimenti Domanda',
  'aet.home.behaviors': 'Indicatori delle prestazioni',
  'aet.home.mostDifficultTopics': 'Domande più difficili',
  'aet.home.commentsFromStudentLabel': 'Commenti da studenti',
  'aet.home.disregard': 'Ignora',
  'aet.home.reportAsInaccurate': 'Segnala come imprecisa',
  'aet.home.Flagged': 'Segnalato',
  'aet.home.reportQuestionTitle': 'Report domanda',
  'aet.home.reportQuestionLabel': 'Cosa c\'era di sbagliato in quella domanda?',
  'aet.home.showComments': 'Mostra commenti',
  'aet.home.studentReports': 'rapporti studenti',
  'aet.home.placeholderText': 'Spiega, per favore...',
  'aet.home.reportQuestion.notRelevant': 'Irrilevante',
  'aet.home.reportQuestion.notCorrect': 'Non corretta',
  'aet.home.reportQuestion.unsafe': 'Non sicuro/Pericoloso',
  'aet.home.reportQuestion.somethingElse': 'Altro',
  'aet.home.StudentDetails.assistedByAI': 'Assistito da IA',
  'aet.home.strugglingStudents.emptyStateTitle': 'Nessuno studente sta avendo difficoltà in questo momento',
  'aet.home.strugglingStudents.emptyStateDescription': 'Verificare di nuovo più tardi.',
  'aet.home.overallStatus.excelling': 'Eccellere',
  'aet.home.overallStatus.fallingBehind': 'Andare indietro',
  'aet.home.overallStatus.keepingUp': 'Tenersi al passo',
  'aet.home.showOnlyDifficultQuestionsLabel': 'Mostra solo “Domande difficili”',
  'aet.home.showOnlyStrugglingStudentsLabel': 'Mostra solo “Studenti in difficoltà”',
  'aet.home.viewQuestionInAssignment': 'Vedi domanda nell’assegnazione',
  'aet.home.insightRisk.incorrectFirstAttempts': 'Primi tentativi errati',
  'aet.home.insightRisk.multipleIncorrectAttempts': 'Più tentativi errati',
  'aet.home.insightRisk.lowConfidence': 'Scarsa sicurezza',
  'aet.home.insightRisk.mediumConfidence': 'Media sicurezza',
  'aet.home.insightRisk.lowEngagement': 'Scarso impegno',
  'aet.home.insightRisk.countOfStudents': '{count} di {total} studenti',
  'aet.home.insightRisk.na': 'N/D',
  'aet.home.strugglingStudentsHereLabel': 'Studenti che hanno difficoltà qui',
  'aet.home.insightRisk.didNotAttempt': 'Non ha tentato',
  'aet.home.insightRisk.attempted': 'Attempted',
  'aet.courseHeader.assignableEText': 'Assignable eText',
  'aet.courseHeader.lmsIntegration': 'Integrazione LMS',
  'aet.courseHeader.lmsIntegrationSubLabel': 'Connected to your LMS',
  'aet.instructorCourse.courseForm.institutionNotOfferedError': 'This institution does not offer this product.'
};

export default it;
